import React, {useEffect, useState} from 'react';
import {BrowserRouter} from 'react-router-dom';
import './assets/styles/App.scss';
import {StoreContext, StoreData} from './store/store';
import Home from './pages/Home/Home';
import LoadingProvider from './context/loadingContext/LoadingProvider';
import {hasCookieConsent} from './utils/cookieUtils';
import {QueryProvider} from "./providers/QueryProvider";
import CookieBanner from "./components/common/Modals/Cookie/CookieBanner";
import {AppRoutes} from "./routes/routes";
import MatomoWrapper from "./components/features/MatomoWrapper/MatomoWrapper";

function App() {
  const [isAnalyticsVisible, setIsAnalyticsVisible] = useState({});
  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(false);

  useEffect(() => {
    if (!hasCookieConsent()) {
      const timeoutId = setTimeout(() => {
        setShowCookieBanner(true);
      }, 3000);

      return () => clearTimeout(timeoutId); // Clear the theme timeout on unmount
    }
  }, []);

  const handleConsent = () => {
    setShowCookieBanner(false);
  };

  const handleReject = () => {
    setShowCookieBanner(false);
  };

  return (
    <StoreContext.Provider
      value={{
        ...new StoreData(),
        isAnalyticsVisible,
        setIsAnalyticsVisible,
      }}
    >
      <QueryProvider>
        <LoadingProvider>
          <BrowserRouter>
            <MatomoWrapper>
              <Home>
                <AppRoutes/>
              </Home>
            </MatomoWrapper>
          </BrowserRouter>
          {showCookieBanner && (
            <CookieBanner onConsent={handleConsent} onReject={handleReject}/>
          )}
        </LoadingProvider>
      </QueryProvider>
    </StoreContext.Provider>
  );
}

export default App;
